import React from 'react'
import Content from './ui/partials/Content'

const BillingConfirmation = () => {
  return <Content />
}

export default BillingConfirmation
